import { useEffect, useState } from "react";
import { uploadThumbnail } from "../services/upload";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { API_BASE_URL } from "../services/config";

const ThumbnailDialog = ({
  open,
  closeDialog,
  thumbnail_file_name,
  selected_id,
  thumbnail_for,
  getData
}) => {

  const [thumbnail_url, set_thumbnail_url] = useState(null);
  const [is_saving_thumbnail, set_is_saving_thumbnail] = useState(false);
  const [selected_file, set_selected_file] = useState(null);

  useEffect(() => {
    const thumbnailURL = Boolean(thumbnail_file_name) ? `${API_BASE_URL}/uploads/thumbnails/${thumbnail_file_name}` : null;
    set_thumbnail_url(thumbnailURL)
  }, [thumbnail_file_name])

  const saveThumbnail = async () => {
    set_is_saving_thumbnail(true);

    const formData = new FormData();
    formData.append('thumbnail_for', thumbnail_for);
    formData.append('document', selected_file);
    const { data } = await uploadThumbnail({
      id: selected_id,
      data: formData
    })

    set_is_saving_thumbnail(false);

    if (data && data.success) {
      enqueueSnackbar('Thumbnail uploaded successfully !', {
        variant: 'success'
      })
      getData();
      closeDialog();
    } else {
      enqueueSnackbar('Error while uploading thumbnail', {
        variant: 'error'
      })
    }
  }

  const handleChangeFile = (e) => {
    const file = e.target.files[0];

    if (file) {
      set_selected_file(file)
      const reader = new FileReader();

      reader.onloadend = () => {
        set_thumbnail_url(reader.result)
      }

      reader.readAsDataURL(file)
    }
  }
  return (
    <Dialog
      open={open}
      onClose={closeDialog}
      fullWidth
      maxWidth='xs'
    >
      <DialogTitle>
        Upload Thumbnail
      </DialogTitle>
      <DialogContent
        dividers
      >
        {
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            border='2px dashed #ccc'
            height={'150px'}
            mb={'20px'}
          >
            {
              thumbnail_url ?
                <img
                  src={thumbnail_url}
                  alt=""
                  style={{
                    height: '100%',
                    width: 'auto',
                    maxWidth: '100%'
                  }}
                /> :
                <Typography
                  color="textDisabled"
                >
                  No File choosen
                </Typography>
            }
          </Box>
        }

        <Box
          display={'flex'}
          justifyContent={'center'}
        >
          <label>
            <input
              type="file"
              style={{
                display: 'none'
              }}
              onChange={handleChangeFile}
            />
            <Button
              component='span'
              variant="contained"
            >
              Choose file
            </Button>
          </label>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={closeDialog}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={saveThumbnail}
          disabled={
            !Boolean(selected_file) ||
            is_saving_thumbnail
          }
        >
          {
            is_saving_thumbnail ?
              <CircularProgress
                size='20px'
              /> :
              'Save'
          }
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ThumbnailDialog;